export default __webpack_public_path__ + "static/new-app-promo-2-250f30cd261f0d1158cae105244d86d7.png";